
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import { useFela } from "react-fela";
import useTranslation from "next-translate/useTranslation";

import { Grid } from "@/components/Grid";
import { useTheme } from "@/hooks/useTheme";
import { Heading } from "@/components/Heading";
import { Head } from "@/components/Head";
import { ConverterFeatures } from "@/containers/ConverterFeatures";

const ConverterFeaturesPage = () => {
  const { css } = useFela();
  const { colors } = useTheme();
  const { t } = useTranslation();

  return (
    <>
      <Head
        pageNamespace="page/converterFeatures"
        ogImage="/images/broken-xd-og-image.jpg"
      />

      <Grid customStyle={{ flexDirection: "column", position: "relative" }}>
        <div
          className={css({
            textAlign: "center",
          })}
        >
          <Heading
            as="h1"
            customStyle={{ color: colors.CHARCOAL, fontSize: 36 }}
          >
            {t("page/converterFeatures:title")}
          </Heading>

          <p
            className={css({
              maxWidth: 950,
              margin: "0 auto",
              paddingBottom: 64,
              lineHeight: "24px",
              letterSpacing: "0.5px",
            })}
          >
            {t("page/converterFeatures:subtitle")}
          </p>
        </div>
        <ConverterFeatures />
      </Grid>
    </>
  );
};

export default ConverterFeaturesPage;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter-features',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  